import Http from './index.js';

//获取作品列表
const getList = (data) => {
    return Http('post', `/branch/tr/queryList.do`, data);
};
//登录
const login = (data) => {
    return Http('post', `/cmn/gmt/getroleinfop.do`, data);
};
//点赞
const lick = (data) => {
    return Http('post', `/branch/tr/like.do`, data);
};
//作品详情
const getDetail = (data) => {
    return Http('post', `/branch/tr/queryDetail.do`, data);
};
//搜索
const search = (data) => {
    return Http('post', `/branch/tr/search.do`, data);
};
//投稿
const contribute = (data) => {
    return Http('post', `/branch/tr/submission.do`, data);
};
export default {
    getList,
    login,
    lick,
    getDetail,
    search,
    contribute
}